export default {
  methods: {
    async initCheckingPrices(
      productDistributorId = null,
      all = false,
      cart = false
    ) {
      await this.$store.dispatch('prices/AddPrices', {
        productDistributorId,
        all,
        cart,
      })
    },
  },
}
